import React, { Component } from 'react';
import { array, string, object, func } from 'prop-types';
import classnames from 'classnames/bind';

import Form from 'components/Form/Form';
import Button from 'elements/Buttons/Button';
import FormField from 'elements/Inputs/FormField';
import InputField from 'elements/Inputs/InputField';

import styles from './WizardForm.css';
const cx = classnames.bind(styles);

export default class WizardForm extends Component {
  static propTypes = {
    inputs: array.isRequired,
    label: object.isRequired,
    successMessage: object,
    className: string,
    onSubmit: func,
  }

  static defaultProps = {
    successMessage: {
      highlighted: 'Thank you!',
      text: 'We will contact you as soon as possible.'
    }
  }

  state = {
    step: 1
  }

  handleButtonClick = e => {
    e.preventDefault();

    this.setState({step: this.state.step + 1});
  }

  renderInputs = () => (
    this.props.inputs.map((input, i) => {
      const inputClass = cx(
        'inputWrapper',
        {activeInputWrapper: this.state.step === (i + 1) }
      );

      return (
        <div className={inputClass} key={`form-field-${input.name}`}>
          <FormField size={'large'} darkBg>
            <InputField prefixProps={{ label: input.label }} placeholder={input.placeholder} />
          </FormField>
        </div>
      );
    })
  );

  renderCounter = () => {
    const { inputs } = this.props;
    const { step } = this.state;

    return (
      <p className={classnames(styles.counter, 'hotspot-title')}>
        {Math.min(step, inputs.length)}
        <span>/{this.props.inputs.length}</span>
      </p>
    );
  }

  renderSuccessMessage = () => {
    const { successMessage } = this.props;

    return (
      <div className={classnames(styles.successMessage,'main-subtitle')}>
        <span className='highlighted'>{successMessage.highlighted}</span>
        &nbsp;{successMessage.text}
      </div>
    );
  };

  render() {
    const { inputs, label, className, onSubmit } = this.props;
    const { step } = this.state;

    const isLastStep = step > inputs.length;
    const progressWidth = `${step * 100 / inputs.length}%`;

    const mainWrapperClasses = cx(
      className,
      'wizardForm',
      'flex',
      {'onLastStep': isLastStep},
    );

    const rightWrapperClasses = cx(
      'right',
      'flex flex-column flex-align-end flex-justify-between',
    );

    return (
      <Form onSubmit={onSubmit}>
        <div className={mainWrapperClasses}>
          <div className={classnames(styles.left, 'flex flex-column flex-justify-between')}>
            <p className="hotspot-title">
              <span className='highlighted'>{label.highlighted}</span>
              &nbsp;{label.text}
            </p>

            <div>
              <div className={styles.inputsContainer}>
                {this.renderInputs()}
              </div>
              <div className={styles.progressLine} style={{width: progressWidth}}></div>
            </div>
          </div>

          <div className={rightWrapperClasses}>
            {this.renderCounter()}
            <Button classes="small secondary white" onClick={this.handleButtonClick}>Next</Button>
          </div>

          {this.renderSuccessMessage()}
        </div>
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/uis/components/Form/WizardForm/WizardForm.js